<template>
  <w-multiple-key-value-filter
    v-bind="$props"
    :override-flat-object="overrideFlatObject"
    :with-false-value="withFalseValue"
    :filter-options="hasFilterOption ? filterOptions : []"
    :filter-option-value="filterOptionValue"
    :option-search-key="attributeOptionSearchKey"
    :option-select-disabled="!moreThanOneAttributesSelected"
    :mandatory-filters="mandatoryFilters"
    v-on="$listeners"
    @input="$emit('input', $event)"
    @update:selected="$emit('update:selected', $event)"
  />
</template>

<script>
import filterHierarchyStructureMixin from '@/mixins/filter-hierarchy-structure-mixin';

import i18n from '@/language/i18n';

const overrideFlatObject = (item) => {
  return {
    id: item.id,
    label: `${item.data.convertLabel}` + ' ' + (item?.data?.attributeName ? `(${item?.data?.attributeName})` : ''),
  };
};

export default {
  name: 'WorkCategoryAttributeFilter',
  props: {
    value: { type: [Object, Array] },
    label: { type: String, default: i18n.t('Common.attribute') },
    filterName: { type: String, default: 'attributes'},
    path: { type: String, default: 'productcategories/attributes' },
    params: { type: Object, default: () => {} },
    itemText: { type: String, default: 'data.convertLabel' },
    itemValue: { type: String, default: 'id' },
    itemChildren: { type: String, default: 'data.discreteValues' },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    attributeOptionSearchKey: { type: String, default: 'attributeRelation' },
    withFalseValue: { type: Boolean, default: true },
    hasFilterOption: { type: Boolean, default: false},
    attributeTableFilters: { type: Object, default: undefined},
    mandatoryFilters: { type: Object, default: undefined },
  },
  methods: {
    overrideFlatObject: overrideFlatObject,
    handleClear() {
      this.$emit('input', []);
    },
  },
  mixins: [
    filterHierarchyStructureMixin(
      self => self.filterName,
      self => self.attributeOptionSearchKey,
      undefined, 
      self => self.attributeTableFilters ?? undefined
    )
  ]
};
</script>
